export default function goToUrl(url, history) {
	if (history && history.push) {
		history.push(url);
	} else {
		window.location.href = url;
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/goToUrl.js